module.exports = __webpack_public_path__ + "static/media/logo-kkv.ef3c8379.svg";